import { useState, useEffect } from 'react';
const LoadingEndpointSpecific = () => {
  const [dots, setDots] = useState('');

  useEffect(() => {
    const interval = setInterval(() => {
      setDots(prev => prev.length >= 3 ? '' : prev + '.');
    }, 500);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="space-y-8">
      {/* Loading Cards */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {/* Availability Card */}
        <div className="bg-white rounded-lg shadow-lg border border-gray-200 p-6 h-64">
          <div className="flex flex-col items-center justify-center h-full space-y-4">
            <div className="w-12 h-12 bg-gray-200 rounded-full animate-pulse"></div>
            <div className="h-6 w-40 bg-gray-200 rounded animate-pulse"></div>
            <div className="h-4 w-32 bg-gray-200 rounded animate-pulse"></div>
            <div className="h-8 w-24 bg-gray-200 rounded animate-pulse"></div>
          </div>
        </div>

        {/* Chart Card */}
        <div className="md:col-span-2 bg-white rounded-lg shadow-lg border border-gray-200 p-6">
          <div className="h-48 flex items-center justify-center">
            <div className="text-center">
              <div className="inline-block animate-spin rounded-full h-12 w-12 border-4 border-gray-200 border-t-blue-900"></div>
              <div className="mt-4 text-lg font-semibold text-gray-600">
                Loading data{dots}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Loading Tables */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {/* Status History */}
        <div className="bg-white rounded-lg shadow-lg border border-gray-200 p-6">
          <div className="h-6 w-36 bg-gray-200 rounded animate-pulse mb-6"></div>
          <div className="space-y-4">
            {[...Array(5)].map((_, i) => (
              <div key={i} className="flex space-x-4">
                <div className="h-4 w-32 bg-gray-200 rounded animate-pulse"></div>
                <div className="h-4 w-20 bg-gray-200 rounded animate-pulse"></div>
              </div>
            ))}
          </div>
        </div>

        {/* Log Data */}
        <div className="bg-white rounded-lg shadow-lg border border-gray-200 p-6">
          <div className="h-6 w-24 bg-gray-200 rounded animate-pulse mb-6"></div>
          <div className="space-y-2">
            {[...Array(6)].map((_, i) => (
              <div key={i} className="h-4 bg-gray-200 rounded animate-pulse"></div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoadingEndpointSpecific;